module.exports = __webpack_public_path__ + "static/d2Res1-d3dcd77c0f14bd5c60724616b44dad69.png";